export default "__VITE_ASSET__CQbNXUkJ__"